import React from "react";
import PropTypes from "prop-types";
import SFButton from "../button";
import { useTranslation } from "react-i18next";

const LoadMoreBtn = (props) => {
  const { t } = useTranslation();
  return (
    <SFButton
      variant="text-link"
      type="button"
      onClick={props.onLoadMore.bind(this, props.limit * 2)}
    >
      {t("components.select.loadMore")}
    </SFButton>
  );
};

LoadMoreBtn.propTypes = {
  limit: PropTypes.number,
  onLoadMore: PropTypes.func,
};

export default LoadMoreBtn;
